import store from '@/store/index.js';
import smElabelApi from './smElabelApi.js';
import smCom from '../global/smCom.js'
import timeHelper from '../global/timeHelper.js';
//获取设备信息
const fSubGetDeviceInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['DEVICE_ID'] = obj.device_id || ''; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['GROUP_ID'] = obj.group_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  // if (obj.oper == 'GET_MAIN') {
  // }
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str;
  js['NOW_PAGE'] = obj.now_page;
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['DSP_PRO_NUM'] = obj.dsp_pro_num || '';
  js['STATE_ID'] = obj.state_id || '';

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_DEVICE_INFO ',
    js
  })
  return res;
}
//商户类别信息查询
const fSubGetMchMallProClsInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['CLS_ID'] = obj.cls_id;


  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_MALL_PRO_CLS_INFO',
    js
  })
  return res;
}
//商户类别信息操作
const fSubMchMallProClsInfo = async (obj) => {
  let js = {};

  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId;
  js['CLS_ID'] = obj.cls_id;
  js['P_CLS_ID'] = obj.p_cls_id;
  js['CLS_NAME'] = obj.cls_name;
  js['CLS_PYM'] = obj.cls_pym;
  js['SORT_ID'] = obj.sort_id;
  js['REMARK'] = obj.remark || '';
  js['STATE_ID'] = obj.state_id || 'sipZc';


  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_MCH_MALL_PRO_CLS_INFO  ',
    js
  })
  return res;
}

//商户商品信息查询
const fSubGetMchMallProInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['CLS_ID'] = obj.cls_id;
  js['PRO_ID'] = obj.pro_id;

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_MALL_PRO_INFO',
    js
  })
  return res;
}
//商户商品信息操作
const fSubMchMallProInfo = async (obj) => {
  let js = {};

  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId;
  js['CLS_ID'] = obj.cls_id;
  js['PRO_ID'] = obj.pro_id;
  js['PRO_ID_EX'] = obj.pro_id_ex;
  js['PRO_NAME'] = obj.pro_name;
  js['PRO_PYM'] = obj.pro_pym;
  js['PRO_UNIT'] = obj.pro_unit;
  js['PRO_SPEC'] = obj.pro_spec;
  js['PRO_ADR'] = obj.pro_adr;
  js['GYS_ID'] = obj.gys_id;
  js['PP_ID'] = obj.pp_id;
  js['PRICE_WAY_ID'] = obj.price_way_id;
  js['SALE_PRICE'] = obj.sale_price;
  js['VIP_PRICE'] = obj.vip_price;
  js['PF_PRICE'] = obj.pf_price;
  js['DIS_PRICE'] = obj.dis_price;
  js['EXP_DAY_NUM'] = obj.exp_day_num;
  js['IMG_URLS'] = obj.img_urls;
  js['VIDEO_URLS'] = obj.video_urls;
  js['REC_YN_ID'] = obj.rec_yn_id;
  js['HOT_YN_ID'] = obj.hot_yn_id;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['SORT_ID'] = obj.sort_id;
  js['REMARK'] = obj.remark || '';

  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_MCH_MALL_PRO_INFO',
    js
  })
  return res;
}
//模板查询 模板
const fMainGetElabelTplLib = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['DSP_PRO_NUM'] = obj.dsp_pro_num || '';
  js['STATE_ID'] = obj.state_id || '';
  js['CLS_ID'] = obj.cls_id || '';

  js['TPL_ID'] = obj.tpl_id;

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_ELABEL_TPL_LIB',
    js
  })
  return res;
}
const MAIN_ELABLE_TPL_LIB = async (oJn) => {
	let js = {}
	js['OPER'] = oJn.oper // 操作
	js['ORG_ID'] = oJn.mch_id // 机构ID
	js['CHG_USER_ID'] = oJn.mch_id // 修改员工ID
	js['TPL_ID'] = oJn.tpl_id // 模板ID
	js['TPL_NAME'] = oJn.tpl_name // 模板名称
	js['TPL_PYM'] = oJn.tpl_pym // 拼音码
	js['CLS_ID'] = oJn.cls_id // 类别id
	js['TPL_JN'] = oJn.tpl_jn || '' // 模板Json
	js['TPL_TXT_JN'] = oJn.tpl_txt_jn || {
		"priceType": '',
		"priceUnit": '',
		"priceColor": '',
		"txt1": '',
		"txt2": '',
		"txt3": '',
		"txt4": '',
		"txt5": '',
		"txt6": '',
		"ctmTxt": '',
	} // 模板txtJson
	js['CNT_IMG_URL'] = oJn.cnt_img_url || '' // 内容图URL
	js['BG_IMG_URL'] = oJn.bg_img_url || '' // 背景图URL
	js['PRE_IMG_URL'] = oJn.pre_img_url || '' // 预览图URL
	js['DSP_VIDEO_NUM'] = oJn.dsp_video_num || 0 // 显示视频数
	js['DSP_PRO_NUM'] = oJn.dsp_pro_num || 1 // 显示商品数
	js['SORT_ID'] = oJn.sort_id || 0 // 排序
	js['REMARK'] = oJn.remark // 备注信息


	let res = await smElabelApi.fElabelMainAdminApi({
		methodName: 'MAIN_ELABLE_TPL_LIB',
		js,
	})
	return res
}
const fSubGetElabelTplInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['DSP_PRO_NUM'] = obj.dsp_pro_num || '';
  js['STATE_ID'] = obj.state_id || '';
  js['CLS_ID'] = obj.cls_id || '';

  js['TPL_ID'] = obj.tpl_id;

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_ELABEL_TPL_INFO',
    js,
    srv_url:obj.srv_url
  })
  return res;
}

//模板查询
const fMainGetImgLib = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';

  js['IMG_MD5'] = obj.img_md5;
  js['IMG_TYPE'] = obj.img_type || 'PRO'; //'BG'

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_IMG_LIB',
    js
  })
  return res;
}

const fGetSubMchVideoInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';

  js['VIDEO_MD5'] = obj.img_md5;
  js['VIDEO_TYPE'] = obj.img_type || 'PRO'; //'BG'

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_VIDEO_INFO',
    js,
    srv_url:obj.srv_url
  })
  return res;
}
const fGetSubMchImgInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';

  js['IMG_MD5'] = obj.img_md5;
  js['IMG_TYPE'] = obj.img_type || 'PRO'; //'BG'

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_IMG_INFO',
    js,
    srv_url:obj.srv_url
  })
  return res;
}

const fMainGetVideoLib = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['VIDEO_FMT'] = 'H264';
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';

  // js['IMG_MD5'] = obj.img_md5 ;
  js['VIDEO_TYPE'] = obj.video_type || 'PRO'; //'BG'

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_VIDEO_LIB',
    js
  })
  return res;
}




//获取设备分组信息
const fSubGetMchMallDeviceGroupInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  // js['NOW_PAGE'] = obj.now_page || '1';
  // js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_MALL_DEVICE_GROUP_INFO',
    js,
    srv_url: obj.srv_url
  })
  return res;
}
const fDeviceOper = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId;
  js['CHG_USER_NAME'] = store.state.smElabelOrgInfo.userName;
  js['DEVICE_ID'] = obj.device_id //'1c2fa2a6675d';
  js['DEVICE_NAME'] = obj.device_name //;
  js['DEVICE_MAKER'] = obj.device_maker || 'ZKSW';
  js['DEVICE_BNS'] = obj.device_bns || '50';
  js['DEVICE_TYPE'] = obj.device_type || 'cbElabel' //
  js['DEVICE_DRT'] = obj.device_drt || 'VERT' //
  js['GROUP_ID'] = obj.group_id //
  js['REMARK'] = obj.remark //
  js['SORT_ID'] = obj.sort_id //
  js['TPL_ID'] = obj.tpl_id //
  js['DEVICE_PROS'] = obj.device_pros //


  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_DEVICE_INFO',
    js,
    srv_url:obj.srv_url
  })
  return res;
}
const fSubElabelDeviceOper = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['DEVICE_MAKER'] = obj.device_maker //'ZKSW';
  js['DEVICE_ID'] = obj.device_id //'1c2fa2a6675d';
  js['DEVICE_BNS'] = obj.device_bns //'50';
  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_ELABEL_DEVICE_OPER ',
    js
  })
  return res;
}

const fSubElabelTplInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  js['CHG_USER_ID'] = obj.chg_user_id || store.state.smElabelOrgInfo.userId;
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['CLS_ID'] = obj.cls_id //
  js['TPL_ID'] = obj.tpl_id //
  js['TPL_NAME'] = obj.tpl_name //
  js['BG_IMG_URL'] = obj.bg_img_url //
  js['CNT_IMG_URL'] = obj.cnt_img_url //
  js['PRE_IMG_URL'] = obj.pre_img_url //
  js['TPL_PYM'] = obj.tpl_pym //
  js['TPL_TXT_JN'] = obj.tpl_txt_jn //
  js['SORT_ID'] = obj.sort_id //
  js['REMARK'] = obj.remark //



  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_MCH_ELABLE_TPL_INFO ',
    js,
    srv_url:obj.srv_url
  })
  console.log(js)
  return res;
}

//获取模板分组信息
const fSubGetMchElabelTplClsInfo = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['ORDER_BY'] = obj.order_by || '';
  js['CLS_ID'] = obj.cls_id || '';
  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MCH_ELABEL_TPL_CLS_INFO',
    js
  })
  return res;
}
//获取模板分组信息
const fMainGetElabelTplLibCls = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['ORDER_BY'] = obj.order_by || '';
  js['CLS_ID'] = obj.cls_id || '';
  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_ELABEL_TPL_LIB_CLS',
    js
  })
  return res;
}

// 获取MQTT消息日志
const fSubGetMqttMsgLog = async (obj) => {
  let js = {};

  js['OPER'] = obj.oper; //'LIST_SIM';
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //;
  js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
  js['QRY_TXT'] = obj.search_str || '';
  js['NOW_PAGE'] = obj.now_page || '1';
  js['PAGE_SIZE'] = obj.page_size || '50';
  js['ORDER_BY'] = obj.order_by || '';
  js['STATE_ID'] = obj.state_id || '';

  let res = await smElabelApi.fElabelSubQueryApi({
    methodName: 'SUB_GET_MQTT_MSG_LOG',
    js
  })
  return res;
}

// 电子价签设备组管理 SUB_MCH_MALL_DEVICE_GROUP_INFO

const SUB_MCH_MALL_DEVICE_GROUP_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper;
  // js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId ;
  js['MCH_ID'] = obj.mch_id // this.smElabelWminSh.mch_id;
  js['MALL_ID'] = '10011001' //
  js['GROUP_ID'] = obj.group_id || '' //
  js['GROUP_NAME'] = obj.group_name || '' //
  js['WIFI_NAME'] = obj.wifi_name || '' //
  js['WIFI_PSW'] = obj.wifi_psw || '' //
  js['GROUP_PYM'] = obj.group_pym || '' //
  js['SORT_ID'] = obj.sort_id || '' //
  js['REMARK'] = obj.remark || '' //

  let res = await smElabelApi.fElabelSubAdminApi({
    methodName: 'SUB_MCH_MALL_DEVICE_GROUP_INFO',
    js,
    srv_url: obj.srv_url
  })
  console.log(js)
  return res;
}

// 主服务器接口
// =============================>
// 获取机构信息 MAIN_GET_ORG_INFO
const MAIN_GET_ORG_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['ORG_ID'] = obj.org_id
  if (obj.oper == 'LIST') {
    js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
    js['QRY_TXT'] = obj.search_str || '';
    js['NOW_PAGE'] = obj.now_page || '1';
    js['PAGE_SIZE'] = obj.page_size || '50';
    js['ORDER_BY'] = obj.order_by || '';
  }
  if (obj.oper == 'ORG_ID') {
    js['ORG_ID'] = obj.org_id
  }
  // js['IMG_MD5'] = obj.img_md5 ;

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_ORG_INFO',
    js
  })
  return res;
}
// 服务商用户登录  MAIN_ORG_USER_LOGIN
const MAIN_ORG_USER_LOGIN = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper // string; // 操作
  js['USER_ID'] = obj.user_id // string; // 操作
  js['USER_PSW'] = obj.user_psw // string; // 操作


  let res = await smElabelApi.fElabelMainAdminApi({
    methodName: 'MAIN_ORG_USER_LOGIN',
    js,
    mchId: obj.user_id,
    userId: obj.user_id
  })
  return res;
}
// 服务商信息 MAIN_ORG_INFO
const MAIN_ORG_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper // string; // 操作
  js['ORG_ID'] = obj.org_id // tring; // 服务商ID
  js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId // string; // 修改服务商员工ID

  if (obj.oper == 'ADD' || obj.oper == 'EDIT') {
    js['ORG_NAME'] = obj.org_name // string; // 服务商名
    js['PROV_CODE'] = obj.prov_code // string; // 省码
    js['CITY_CODE'] = obj.city_code // string; // 市码
    js['AREA_CODE'] = obj.area_code // string; // 区码
    js['ADR_DETAIL'] = obj.adr_detail // string; // 详细地址
    js['YEAR_MONEY'] = obj.year_money // string; // 年费
    js['STOP_TIME'] = obj.stop_time // string; // 到期时间
    js['SRV_IP'] = obj.srv_id // string; // 服务器地址
    js['CAN_REG_NUM'] = obj.can_reg_num // string; // 可注册商户数
    js['ORG_PSW'] = obj.org_psw //string; //
    js['CMS_WAY'] = obj.cms_way // string; // 分润方式
    js['CMS_RATE'] = obj.cms_rate // string; // 分润系数
    js['ELABEL_WIFI'] = obj.elabel_wifi // string; // 电子价签WIFI
    js['ELABEL_WIFI_PSW'] = obj.elabel_wifi_psw // string; // 电子价签WIFI密码
    js['ORG_PYM'] = obj.org_pym //string; // 服务商拼音码
    js['MCC_CODE'] = obj.mcc_code //string; // 行业编码
    js['MCC_DETAIL'] = obj.mcc_detail //string; // 主要经营
    js['BOSS_NAME'] = obj.boss_name //string; // 老板名称
    js['BOSS_PHONE'] = obj.boss_phone //string; // 老板电话
    js['OEM_YN'] = obj.oem_yn //string; // 是否OEM
    js['REMARK'] = obj.remark //string; // 备注
    js['STATE_ID'] = obj.state_id // : string; // 状态ID
  }



  let res = await smElabelApi.fElabelMainAdminApi({
    methodName: 'MAIN_ORG_INFO',
    js
  })
  return res;
}



// 获取商户信息 MAIN_GET_MCH_INFO
const MAIN_GET_MCH_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['STATE_ID'] = obj.state_id || 'sipZc';
  js['ORG_ID'] = obj.org_id
  if (obj.oper == 'LIST') {
    js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
    js['QRY_TXT'] = obj.search_str || '';
    js['NOW_PAGE'] = obj.now_page || '1';
    js['PAGE_SIZE'] = obj.page_size || '50';
    js['ORDER_BY'] = obj.order_by || '';
  }
  if (obj.oper == 'MCH_ID') {
    js['MCH_ID'] = obj.mch_id
  }
  // js['IMG_MD5'] = obj.img_md5 ;

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_MCH_INFO',
    js
  })
  return res;
}

// 商户信息  MAIN_MCH_INFO
const MAIN_MCH_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper // string; // 操作
  js['ORG_ID'] = obj.org_id // tring; // 服务商ID
  js['CHG_USER_ID'] = store.state.smElabelOrgInfo.userId // string; // 修改服务商员工ID
  js['CHG_ORG_ID'] = store.state.smElabelOrgInfo.orgId // string; // 修改服务商员工ID
  js['MCH_ID'] = obj.mch_id // string; // 服务商名


  if (obj.oper == 'ADD' || obj.oper == 'EDIT') {
    js['MCH_NAME'] = obj.mch_name // string; // 服务商名
    js['MCH_PSW'] = obj.mch_psw //string; //
    js['MCH_PYM'] = obj.mch_pym //string; // 服务商拼音码
    js['PROV_CODE'] = obj.prov_code // string; // 省码
    js['CITY_CODE'] = obj.city_code // string; // 市码
    js['AREA_CODE'] = obj.area_code // string; // 区码
    js['ADR_DETAIL'] = obj.adr_detail // string; // 详细地址
    js['MCC_CODE'] = obj.mcc_code //string; // 行业编码
    js['MCC_DETAIL'] = obj.mcc_detail //string; // 主要经营
    js['BOSS_NAME'] = obj.boss_name //string; // 老板名称
    js['BOSS_PHONE'] = obj.boss_phone //string; // 老板电话
    js['DEVICE_YEAR_AMT'] = obj.device_year_amt // string; // 年费
    js['SOFT_NAME'] = obj.soft_name // string; // 软件名称
    js['SOFT_MCH_ID'] = obj.soft_mch_id // string; // 软件商户号
    js['SOFT_MALL_ID'] = obj.soft_mall_id // string; // 软件门店号
    js['YW_ORG_USER_ID'] = obj.yw_org_user_id // string; // 机构业务员ID
    js['CHG_ORG_USER_ID'] = store.state.smElabelOrgInfo.orgId // string; // 机构修改员ID
    js['REMARK'] = obj.remark //string; // 备注
    js['STATE_ID'] = obj.state_id // : string; // 状态ID
    js['SORT_ID'] = obj.sort_id // : string; // 排序ID
  }
  if (obj.oper == 'DEL') {}

  if (obj.oper == 'EDIT_WIFI') {
    js['WIFI_NAME'] = obj.wifi_name //
    js['WIFI_PSW'] = obj.wifi_psw // :
  }
  let res = await smElabelApi.fElabelMainAdminApi({
    methodName: 'MAIN_MCH_INFO',
    js
  })
  return res;
}

// 获取设备信息 MAIN_GET_DEVICE_INFO
const MAIN_GET_DEVICE_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['STATE_ID'] = obj.state_id || '';
  js['ORG_ID'] = obj.org_id
  if (obj.oper == 'LIST') {
    js['QRY_LIKE_YN'] = obj.mhYn || 'Y';
    js['QRY_TXT'] = obj.search_str || '';
    js['NOW_PAGE'] = obj.now_page || '1';
    js['PAGE_SIZE'] = obj.page_size || '50';
    js['ORDER_BY'] = obj.order_by || '';
  }

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_DEVICE_INFO',
    js
  })
  return res;
}

// 电子价签设备管理 MAIN_DEVICE_INFO
const MAIN_DEVICE_INFO = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper // string; // 操作
  js['MCH_ID'] = obj.mch_id // string;
  js['MALL_ID'] = '10011001' // string;
  js['DEVICE_ID'] = obj.device_id // string;
  js['YEAR_AMT'] = obj.year_amt // string; // 年费
  js['STOP_TIME'] = obj.stop_time // string; //
  let res = await smElabelApi.fElabelMainAdminApi({
    methodName: 'MAIN_DEVICE_INFO',
    js
  })
  return res;
}


// 获取概况数据  MAIN_GET_OVW_DATA
const MAIN_GET_OVW_DATA = async (obj) => {
  let js = {};
  js['OPER'] = obj.oper; //'LIST_SIM';
  js['ORG_ID'] = obj.org_id

  let res = await smElabelApi.fElabelMainQueryApi({
    methodName: 'MAIN_GET_OVW_DATA',
    js
  })
  return res;
}
export default {
  fSubGetDeviceInfo,
  fSubGetMchMallDeviceGroupInfo,
  fSubElabelDeviceOper,
  fDeviceOper,
  fSubMchMallProClsInfo,
  fSubGetMchMallProClsInfo,
  fSubGetMchMallProInfo,
  fSubMchMallProInfo,
  fMainGetElabelTplLib,
  fMainGetImgLib,
  fGetSubMchImgInfo,
  fMainGetVideoLib,
  fSubGetElabelTplInfo,
  fSubElabelTplInfo,
  fSubGetMchElabelTplClsInfo,
  fSubGetMqttMsgLog,
  fMainGetElabelTplLibCls,
  SUB_MCH_MALL_DEVICE_GROUP_INFO,
  fGetSubMchVideoInfo,
  //服务商接口
  MAIN_GET_ORG_INFO,
  MAIN_ORG_INFO,
  MAIN_ORG_USER_LOGIN,
  MAIN_MCH_INFO,
  MAIN_GET_MCH_INFO,
  MAIN_GET_DEVICE_INFO,
  MAIN_DEVICE_INFO,
  MAIN_GET_OVW_DATA,
  MAIN_ELABLE_TPL_LIB
}



//////////////////
// WEBPACK FOOTER
// ./common/api/smCommon.js
// module id = null
// module chunks = 